import { render, staticRenderFns } from "./SkillsChipsV2.vue?vue&type=template&id=19692416&scoped=true&"
import script from "./SkillsChipsV2.vue?vue&type=script&lang=ts&"
export * from "./SkillsChipsV2.vue?vue&type=script&lang=ts&"
import style0 from "./SkillsChipsV2.vue?vue&type=style&index=0&id=19692416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19692416",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VCol,VRow,VSkeletonLoader})
